import {
  QuizFragmentFragment,
  QuizSortInput,
  Sort,
} from '../../apollo/__generated__/graphql.ts';
import { ISortObj } from '../table/table-utils.ts';

type ISpecialKeys = '_checkbox';
export type IQuizTableKeys =
  | keyof Pick<
      QuizFragmentFragment,
      | 'id'
      | 'name'
      | 'description'
      | 'quizQuestions'
      | 'status'
      | 'created'
      | 'createdAt'
    >
  | ISpecialKeys;
export type IQuizzesTableKeys = keyof QuizSortInput;
export const quizzesSortKeys: IQuizzesTableKeys[] = [
  'createdAt',
  'description',
  'id',
  'name',
  'status',
  'created',
];

type IColumn = {
  title: string;
  key: IQuizTableKeys;
  className?: string;
};
export const quizzesColumns: IColumn[] = [
  { key: '_checkbox', title: '' },
  { key: 'name', title: 'Name' },
  { key: 'description', title: 'Description' },
  { key: 'quizQuestions', title: 'Questions', className: 'w-20' },
  { key: 'createdAt', title: 'Created At' },
  { key: 'status', title: 'Status' },
  { key: 'id', title: 'Id' },
  { key: 'created', title: 'Created' },
];

export const initialQuizzesSort: ISortObj = {
  createdAt: Sort.Desc,
  description: undefined,
  id: undefined,
  name: undefined,
  questionCount: undefined,
  status: undefined,
};
